import React, { Component, PropTypes } from 'react';
import Page from './Page';

class NotFoundPageBody extends Component {

  static contextTypes = {
    flux: PropTypes.object.isRequired
  }

  componentWillMount() {
    const { flux } = this.context;

    flux.getActions('Helmet').update({
      title: 'Page not found',
      statusCode: 404
    });
  }

  render() {
    return <h1>404 - Page not found</h1>;
  }

}

class NotFoundPage extends Component {
  render() {
    const bodyComponent = <NotFoundPageBody />;

    return (
      <Page body={bodyComponent} />
    );
  }
}

export default NotFoundPage;



// WEBPACK FOOTER //
// ./app/components/core/NotFoundPage.js